module.exports = __webpack_public_path__ + "img/divina.4a0276ee.jpg";